"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Heading = exports.Caption = void 0;

var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));

var _knownCssProperties = require("known-css-properties");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _typographyStyles = require("./typography-styles");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * Should forward prop.
 */
function shouldForwardProp(propName) {
  return !_knownCssProperties.all.includes((0, _kebabCase2["default"])(propName));
}
/**
 * Set type style.
 */


function setTypeStyle(element) {
  return (0, _styledComponents.css)(["", ""], _typographyStyles.typography.styles[element]);
}
/**
 * Heading level cases.
 */


var headingLevelCases = {
  h1: (0, _styledComponents.css)(["", ""], setTypeStyle('heading1')),
  h2: (0, _styledComponents.css)(["", ""], setTypeStyle('heading2')),
  h3: (0, _styledComponents.css)(["", ""], setTypeStyle('heading3')),
  h4: (0, _styledComponents.css)(["", ""], setTypeStyle('heading4'))
};
/**
 * Export `Heading` component.
 */

var Heading = _styledComponents["default"].p.withConfig({
  shouldForwardProp: shouldForwardProp
}).attrs(function (_ref) {
  var as = _ref.as,
      level = _ref.level;
  var element = as !== null && as !== void 0 ? as : level;
  return {
    as: element
  };
}).withConfig({
  displayName: "typography__Heading",
  componentId: "sc-fah80m-0"
})(["", " ", " ", ""], (0, _styledTools.theme)('typography.fontSettings'), (0, _styledTools.switchProp)('level', headingLevelCases, headingLevelCases.h3), _styles.setStyledProps);
/**
 * Text size cases.
 */


exports.Heading = Heading;
var textSizeCases = {
  extraSmall: (0, _styledComponents.css)(["", ""], setTypeStyle('textExtraSmall')),
  large: (0, _styledComponents.css)(["", ""], setTypeStyle('textLarge')),
  medium: (0, _styledComponents.css)(["", ""], setTypeStyle('textMedium')),
  normal: (0, _styledComponents.css)(["", ""], setTypeStyle('textNormal')),
  small: (0, _styledComponents.css)(["", ""], setTypeStyle('textSmall'))
};
/**
 * Export `Text` component.
 */

var Text = _styledComponents["default"].p.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "typography__Text",
  componentId: "sc-fah80m-1"
})(["", " ", " ", ""], (0, _styledTools.theme)('typography.fontSettings'), (0, _styledTools.switchProp)('size', textSizeCases, textSizeCases.normal), _styles.setStyledProps);
/**
 * Caption size cases.
 */


exports.Text = Text;
var captionSizeCases = {
  extraSmall: (0, _styledComponents.css)(["", ""], setTypeStyle('captionExtraSmall')),
  medium: (0, _styledComponents.css)(["", ""], setTypeStyle('captionMedium')),
  small: (0, _styledComponents.css)(["", ""], setTypeStyle('captionSmall'))
};
/**
 * Export `Caption` component.
 */

var Caption = _styledComponents["default"].label.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "typography__Caption",
  componentId: "sc-fah80m-2"
})(["", " ", " ", ""], (0, _styledTools.theme)('typography.fontSettings'), (0, _styledTools.switchProp)('size', captionSizeCases), _styles.setStyledProps);

exports.Caption = Caption;